






















































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Dish } from '@/api/model/dish';
import CategoryHeader from '@/components/menu-engineering/CategoryHeader.vue';

@Component({
  components: { CategoryHeader },
})
export default class DishList extends Vue {
  @Prop(Boolean)
  showTitle!: boolean;

  @Prop(String)
  course!: string;

  @Prop(String)
  restaurantName!: string;

  @Prop(Array)
  dishes!: Dish[];

  @Prop({ default: false })
  showHeader!: boolean;

  @Prop({ default: false })
  showDishCount!: boolean;

  @Prop(String)
  score!: string;

  @Emit()
  deleteDish() {}
}
